module.exports = __webpack_public_path__ + "static/media/Raportowanie.dff9cd8c.png";